import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Image from '../Image';
import { images } from 'utils/icons';
import styles from './index.module.scss';
import { makeStyles } from '@material-ui/core';
import cn from 'classnames';

const useStyles = makeStyles({
  outlineLoaderWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const Loader = ({ outline, className }) => {
  const classes = useStyles();
  return outline ? (
    <div className={cn(classes.outlineLoaderWrapper, className)}>
      <CircularProgress />
    </div>
  ) : (
    <div className={styles.center}>
      <Image src={images.srmLogo.default} className={styles.logoSpin} />
    </div>
  );
};

Loader.propTypes = {
  outline: PropTypes.bool,
  className: PropTypes.string,
};

export default Loader;
